import { instance } from '@/api/instances'

const fetchCategories = async store => {
  store.commit('setLoading', true)
  store.commit('setCurrentProtocol', undefined)

  try {
    const categories = await instance.get('bud/categories')
    store.commit('setCategories', categories)
  } catch (error) {
    store.dispatch(
      'errors/setError',
      {
        error,
        context: 'bud',
        request: 'bud/fetchCategories'
      },
      { root: true }
    )
  } finally {
    store.commit('setLoading', false)
  }
}

const searchProtocols = async (store, name) => {
  try {
    const protocols = await instance.get(`bud/protocols?name=${name}`)

    store.commit('setProtocolsResult', protocols)
  } catch (error) {
    // do nothing
  }
}

const fetchProtocolNodes = async (store, budId) => {
  store.commit('setLoading', true)

  try {
    const currentProtocol = await instance.post(`bud/navigate/${budId}`, {
      json: {}
    })

    store.commit('setCurrentProtocol', currentProtocol)
  } catch (error) {
    store.dispatch(
      'errors/setError',
      {
        error,
        context: 'bud',
        request: 'bud/fetchProtocolNodes'
      },
      { root: true }
    )
  } finally {
    store.commit('setLoading', false)
  }
}

const fetchNodeRelationships = async (store, { nodeId, navigation }) => {
  store.commit('setLoading', true)
  if (!store.state.currentProtocol) {
    store.commit('setLoading', false)
    return
  }
  let navigationBody = {}
  if (navigation?.personId) {
    navigationBody = {
      personId: {
        id: navigation.personId
      },
      scriptNodeId: navigation.scriptNodeId,
      previousNodeId: navigation.previousNodeId,
      relationshipId: navigation.relationshipId
    }
    navigationBody.source = getSource(
      navigation.channelId,
      navigation.appointmentId
    )
  }
  try {
    const nodeWithRelationships = await instance.post(
      `bud/navigate/${nodeId}`,
      {
        json: navigationBody
      }
    )

    store.commit('updateCurrentProtocol', nodeWithRelationships)
  } catch (error) {
    // do nothing
  }

  store.commit('setLoading', false)
}

const getNavigationHistory = async (
  store,
  { personId, channelId, appointmentId }
) => {
  try {
    if (!personId) {
      return
    }
    const source = getSource(channelId, appointmentId)
    const params = source ? `source=${JSON.stringify(source)}` : ''
    const navigationHistory = await instance.get(
      `bud/${personId}/lastNavigation?${params}`
    )

    store.commit('setNavigationHistory', navigationHistory)
  } catch (error) {
    // do nothing
  }
}

const deleteNavigationHistory = async (
  store,
  { personId, channelId, appointmentId, nodeId }
) => {
  try {
    if (!personId) {
      return
    }
    const source = getSource(channelId, appointmentId)
    const params = source ? `source=${JSON.stringify(source)}` : ''
    await instance.post(`bud/${personId}/finishNavigation/${nodeId}?${params}`)
    store.commit('clearNavigationHistory')
  } catch (error) {
    //do nothing
  }
}

const sendToChannel = (store, { channelId, message }) => {
  store.commit('sentToChannels', true)

  store.commit(
    'pillars/channel/message/handleBudMessage',
    { channelId, message },
    { root: true }
  )

  setTimeout(() => {
    store.commit('sentToChannels', false)
  }, 3000)
}

const triggerAction = async (store, { nodeId, actionId, body }) => {
  try {
    return await instance.post(`bud/${nodeId}/action/${actionId}`, {
      json: body
    })
  } catch (error) {
    store.dispatch(
      'errors/setError',
      {
        error,
        context: 'bud',
        request: 'bud/triggerAction'
      },
      { root: true }
    )
  }
}

const triggerActionV2 = async (store, { nodeId, actionId, body }) => {
  try {
    return await instance.post(`bud/${nodeId}/action/v2/${actionId}`, {
      json: body
    })
  } catch (error) {
    store.dispatch(
      'errors/setError',
      {
        error,
        context: 'bud',
        request: 'bud/triggerActionV2'
      },
      { root: true }
    )
  }
}

const clearState = store => {
  store.commit('setCurrentProtocol', undefined)
  store.commit('clearNavigationHistory')
}

const getSource = (channelId, appointmentId) => {
  if (channelId != null) {
    return {
      type: 'CHANNEL',
      id: channelId
    }
  } else if (appointmentId != null) {
    return {
      type: 'APPOINTMENT',
      id: appointmentId
    }
  }
  return null
}

export default {
  fetchCategories,
  searchProtocols,
  fetchProtocolNodes,
  fetchNodeRelationships,
  sendToChannel,
  triggerAction,
  triggerActionV2,
  getNavigationHistory,
  deleteNavigationHistory,
  clearState
}
